<template>
  <v-col cols="12">
    <v-card class="px-2 py-2" v-if="hasPermissionToVisualize()">
    <v-card-title>
      <label style="color: gray">{{ title }}</label>
      <v-spacer />
      <v-btn v-if="isAccessPermission() && hasPermissionToModify()"
        color="muted-accent"
        text
        icon
        @click="newItem"
      >
        <v-icon>mdi-plus-circle</v-icon>
      </v-btn>
    </v-card-title>
    <v-simple-table v-if="items.length">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left" width="1%" v-if="isAccessPermission() && hasPermissionToModify()"></th>
          <th class="text-left" width="1%" v-if="isAccessPermission() && hasPermissionToModify()"></th>
          <th class="text-left">Tipo</th>
          <th class="text-left" v-if="!isAccessPermission()">Caminho</th>
          <th class="text-left">Valor</th>
          <th class="text-center">Permissão</th>
          <th class="text-center">Upload</th>
          <th class="text-center">Renomear</th>
          <th class="text-center">Criar</th>
          <th class="text-center">Excluir</th>
          <th class="text-center">Ativa</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in items"
          :key="item.id"
        >
          <td v-if="isAccessPermission() && hasPermissionToModify()">
            <v-icon small class="mr-2"
                    @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </td>
          <td v-if="isAccessPermission() && hasPermissionToModify()">
            <v-icon small class="mr-2"
                    @click="deleteItem(item)">
              mdi-trash-can
            </v-icon>
          </td>
          <td>{{ getTypeRuleDescription(item.typeRule) }}</td>
          <td v-if="!isAccessPermission()">{{ item.path }}</td>
          <td>{{ item.accessJson }}</td>
          <td><CheckboxPermission v-if="isUser(item.typeRule) || isFirewall()" :value="item.permission "/></td>
          <td><CheckboxPermission v-if="isNotGlobal(item.typeRule)" :value="item.upload "/></td>
          <td><CheckboxPermission v-if="isNotGlobal(item.typeRule)" :value="item.rename "/></td>
          <td><CheckboxPermission v-if="isNotGlobal(item.typeRule)" :value="item.add "/></td>
          <td><CheckboxPermission v-if="isNotGlobal(item.typeRule)" :value="item.delete "/></td>
          <td><CheckboxPermission :value="item.active "/></td>
        </tr>
        </tbody>
      </template>
      <template v-slot:no-data>
        Nenhuma regra configurada
      </template>
    </v-simple-table>
    <label v-else class="px-3 d-flex justify-center" style="color: gray">Nenhuma regra configurada</label>
    <DialogItem ref="dialogItem"
                :open="openDialogItem"
                :editedItem="editedItem"
                :editing="editing"
                :path="path"
                :user-role-creation="userRoleCreation"
                :user-role-apply="userRoleApply"
                :allowed-type-rules="allowedTypeRules"
                v-on:closeDialogItem="closeDialogItem"
                v-on:saveDialogItem="saveDialogItem" />
    <DeletionConfirmationModal :open="deleting" :item="deletedItem" @close="stopDeletingItem" @confirm="confirmItemDeletion"/>
  </v-card>
  </v-col>
</template>

<script>
import {
  saveAccessPermission, editAccessPermission, deleteAccessPermission, listAccessPermissionBy, getCurrentUser,
} from '@/common/driveserver';
import DialogItem from './DialogItem.vue';
import DeletionConfirmationModal from './DeletionConfirmationModal.vue';
import CheckboxPermission from './CheckboxPermission.vue';

export default {
  name: 'ShowAccessPermission',
  components: {
    DialogItem,
    DeletionConfirmationModal,
    CheckboxPermission,
  },
  data: () => ({
    openDialogItem: false,
    editedItem: {},
    editing: false,
    items: [],
    deletedItem: {},
    deleting: false,
    authorities: [],
    allTypeRules: [
      { id: 'GLOBAL', value: 'Global' },
      { id: 'CONTRACT', value: 'Contrato' },
      { id: 'SUBCONTRACT', value: 'Contrato' },
      { id: 'PROFILE', value: 'Perfil' },
      { id: 'USER', value: 'Usuário' },
    ],
  }),
  props: {
    title: {
      type: String,
      required: true,
    },
    userRoleCreation: {
      type: String,
      required: true,
    },
    userRoleApply: {
      type: String,
      required: false,
    },
    screenType: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      required: false,
    },
    visualizePermission: {
      type: String,
      required: false,
    },
    modifyPermission: {
      type: String,
      required: false,
    },
    allowedTypeRules: {
      type: Array,
      required: false,
    },
  },
  methods: {
    isAccessPermission() {
      return this.screenType === 'ACCESS_PERMISSION';
    },
    isFirewall() {
      return this.screenType === 'FIREWALL';
    },
    hasPermissionToVisualize() {
      return !this.visualizePermission || this.verifyPermission(this.visualizePermission);
    },
    hasPermissionToModify() {
      return !this.modifyPermission || this.verifyPermission(this.modifyPermission);
    },
    verifyPermission(permission) {
      if (this.authorities) {
        const authority = this.authorities.filter((a) => a.authority === permission);
        return authority.length > 0;
      }
      return false;
    },
    loadItems() {
      const accessPermission = {
        screenType: this.screenType,
        userRoleCreation: this.userRoleCreation,
        userRoleApply: this.userRoleApply,
        path: this.path,
      };
      listAccessPermissionBy(accessPermission)
        .then((response) => {
          this.items = response.data;
        })
        .catch(() => {
        });
    },
    newItem() {
      this.editedItem = {
        permission: false,
        active: true,
        upload: false,
        add: false,
        rename: false,
        delete: false,
        path: '',
        ruleConfigs: [],
      };
      this.openDialogItem = true;
      this.editing = false;
    },
    deleteItem(item) {
      this.deletedItem = item;
      this.deleting = true;
    },
    stopDeletingItem() {
      this.deleting = false;
      this.deletedItem = {};
    },
    confirmItemDeletion(item) {
      this.deleting = false;
      this.loadingContent = true;
      deleteAccessPermission(item.id)
        .then(() => {
          this.loadingContent = false;
          this.items.splice(this.items.findIndex((i) => i.id === item.id), 1);
        })
        .catch(() => {
          this.showMessageErro('Ocorreu um erro ao excluir o registro');
          this.loadingContent = false;
        });
    },
    editItem(item) {
      this.editedItem = item;
      this.openDialogItem = true;
      this.editing = true;
    },
    closeDialogItem() {
      this.openDialogItem = false;
      this.editedItem = {};
    },
    saveDialogItem(item) {
      this.loadingContent = true;
      this.openDialogItem = false;
      this.loadingContent = false;
      if (this.editing) {
        editAccessPermission(item, item.id)
          .then(() => {
            this.openDialogItem = false;
            this.loadingContent = false;
            this.items.splice(this.items.findIndex((i) => i.id === item.id), 1);
            this.items.push(item);
          })
          .catch(() => {
            this.showMessageErro('Ocorreu um erro ao salvar o registro');
            this.loadingContent = false;
          });
      } else {
        saveAccessPermission(item)
          .then((response) => {
            this.openDialogItem = false;
            this.loadingContent = false;
            // eslint-disable-next-line no-param-reassign
            item.id = response.data.id;
            this.items.push(item);
          })
          .catch(() => {
            this.showMessageErro('Ocorreu um erro ao inserir o registro');
            this.loadingContent = false;
          });
      }
    },

    getTypeRuleDescription(typeRule) {
      let ruleDescription = '';
      this.allTypeRules.forEach((tr) => {
        if (tr.id === typeRule) {
          ruleDescription = tr.value;
        }
      });
      return ruleDescription;
    },
    isNotGlobal(typeRule) {
      return typeRule && typeRule !== 'GLOBAL';
    },
    isUser(typeRule) {
      return typeRule && typeRule === 'USER';
    },
  },
  async created() {
    const currentUser = await getCurrentUser(this.token);
    this.authorities = currentUser.authorities;
    this.loadItems();
  },
};
</script>
